// Punto ÚNICO de acceso al servicio de estructura, con la firma
// `(credentials, data) => Promise<nodo[]>`.
//
// Hubo acá un mock alternable por comentarios; se borró junto con el archivo
// ../mock/RNHEstablecimientoEstructuraGetMock. Si vuelve a hacer falta trabajar sin
// back, se rehace apuntando getEstructura al mock desde este mismo archivo.

import { RNHEstablecimientoEstructuraGet } from "services/services-mia/programa-salud/estructuras/RNHEstablecimientoEstructuraGet";

export const getEstructura = RNHEstablecimientoEstructuraGet;
